<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <ValidationProvider v-slot="{ errors }" :name="tipo" :rules="regras">
        <v-text-field
          v-model="dataFormatada"
          :label="nome"
          :hint="dica != null ? dica : ''"
          prepend-icon="mdi-calendar"
          :error-messages="errors"
          @change="dataDigitada(dataFormatada)"
          @focus="menu = true"
          v-on="on"
          v-mask="'##/##/####'"
          :disabled="!habilitarDataJuros"
        ></v-text-field>
      </ValidationProvider>
    </template>
    <v-date-picker
      v-model="data"
      locale="pt-br"
      color="#2f598b"
      @input="menu = false"
      :allowed-dates="datasPermitidas"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import { ValidationProvider, setInteractionMode } from "vee-validate";
setInteractionMode("eager");
import { mapActions } from "vuex";

let hoje = new Date();
hoje = new Date(hoje.getTime() - hoje.getTimezoneOffset() * 60000)
  .toISOString()
  .split("T")[0];

export default {
  name: "DatePicker",
  props: {
    nome: {
      type: String,
      default: "Data"
    },
    regras: {
      type: String,
      default: ""
    },
    tipo: {
      type: String
    },
    dica: {
      type: String,
      default: null
    },
    habilitarDataJuros: {
    type: Boolean,
    default: true
    },
  },
  data: () => ({
    dataFormatada: null,
    menu: false,
  }),
  computed: {
    dataInicialPermitida: function() {
      if (
        this.$store.state.dataValorOriginal &&
        this.tipo != "dataValorOriginal"
      ) {
        return this.$store.state.dataValorOriginal;
      }
      return "01/01/1980";
    },
    dataFinalPermitida: function() {
      if (this.$store.state.dataAtualizacao && this.tipo != "dataAtualizacao") {
        return this.$store.state.dataAtualizacao;
      }
      return hoje;
    },
    data: {
      get() {
        let data = null;
        switch (this.tipo) {
          case "dataValorOriginal":
            data = this.$store.state.dataValorOriginal;
            break;
          case "dataJuros":
            data = this.$store.state.dataJuros;
            break;
          case "dataAtualizacao":
            data = this.$store.state.dataAtualizacao;
            break;
        }
        return data;
      },
      set(novaData) {
        switch (this.tipo) {
          case "dataValorOriginal":
            this.setDataValorOriginal(novaData);
            break;
          case "dataJuros":
            this.setDataJuros(novaData);
            break;
          case "dataAtualizacao":
            this.setDataAtualizacao(novaData);
            break;
        }
      }
    }
  },
  mounted() {
    if (this.tipo == "dataAtualizacao") {
      this.setDataAtualizacao(hoje);
    }
  },
  components: {
    ValidationProvider
  },
  watch: {
    data(valor) {
      this.dataFormatada = this.formatarData(valor);
    },
  },
  methods: {
    ...mapActions([
      "setDataValorOriginal",
      "setDataJuros",
      "setDataAtualizacao"
    ]),
    formatarData(data) {
      if (!data) return null;

      const [ano, mes, dia] = data.split("-");
      return `${dia}/${mes}/${ano}`;
    },
    desformatarData(data) {
      if (!data) return null;

      const [dia, mes, ano] = data.split("/");
      return `${ano}-${mes.padStart(2, "0")}-${dia.padStart(2, "0")}`;
    },
    dataDigitada(data) {
      let dataDesformatada = this.desformatarData(data);
      switch (this.tipo) {
        case "dataValorOriginal":
          this.setDataValorOriginal(dataDesformatada);
          break;
        case "dataJuros":
          this.setDataJuros(dataDesformatada);
          break;
        case "dataAtualizacao":
          this.setDataAtualizacao(dataDesformatada);
          break;
      }
      this.menu = false;
    },
    datasPermitidas(data) {
      return (
        data >= this.dataInicialPermitida && data <= this.dataFinalPermitida
      );
    }
  }
};
</script>

<style lang="scss" scoped></style>
